unit View.Origem_Csosn.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewOrigem_CsosnEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbcodigo: TLabel;
    edcodigo: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientOrigem_CsosnGet: TXDataWebClient;
    XDataClientOrigem_CsosnDelete: TXDataWebClient;
    Origem_CsosnDataset: TXDataWebDataSet;
    Origem_CsosnDatasetnome: TStringField;
    Origem_CsosnDatasetcodigo: TIntegerField;
    Origem_CsosnDatasetexcluido: TBooleanField;
    Origem_CsosnDatasetinclusao: TDateTimeField;
    Origem_CsosnDatasetalteracao: TDateTimeField;
    Origem_CsosnDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientOrigem_CsosnGetLoad(Response: TXDataClientResponse);
    procedure XDataClientOrigem_CsosnDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientOrigem_CsosnDeleteError(Error: TXDataClientError);
    procedure Origem_CsosnDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewOrigem_CsosnEdit: TFViewOrigem_CsosnEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewOrigem_CsosnEdit }

procedure TFViewOrigem_CsosnEdit.btSaveClick(Sender: TObject);
begin
  if Origem_CsosnDataset.State in dsEditModes then
  begin
        Origem_CsosnDataset.Post;
    Origem_CsosnDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewOrigem_CsosnEdit.btDeleteClick(Sender: TObject);
begin
  if Origem_CsosnDataset.State in dsEditModes then
    Origem_CsosnDataset.Post;
  XDataClientOrigem_CsosnDelete.Delete(Origem_CsosnDataset.EntitySetName,
    TJSObject(Origem_CsosnDataset.CurrentData));
end;


class function TFViewOrigem_CsosnEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewOrigem_CsosnEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewOrigem_CsosnEdit.InsertEntity;
begin
  Origem_CsosnDataset.Close;
  Origem_CsosnDataset.SetJsonData('{}');
  Origem_CsosnDataset.Open;
  Origem_CsosnDataset.Insert;
end;

class function TFViewOrigem_CsosnEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewOrigem_CsosnEdit(AForm).FInserting := AInserting;
    TFViewOrigem_CsosnEdit(AForm).FId := AId;
    TFViewOrigem_CsosnEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewOrigem_CsosnEdit(AForm).InsertEntity
    else
      TFViewOrigem_CsosnEdit(AForm).LoadEntity;
    TFViewOrigem_CsosnEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewOrigem_CsosnEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewOrigem_CsosnEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Origem_CsosnDataset.Connection.Model.DefaultSchema.FindEntityType(
      Origem_CsosnDataset.EntitySetName
    )
  );
  XDataClientOrigem_CsosnGet.Get(Origem_CsosnDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewOrigem_CsosnEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewOrigem_CsosnEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewOrigem_CsosnEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewOrigem_CsosnEdit.XDataClientOrigem_CsosnGetLoad(Response: TXDataClientResponse);
begin
  Origem_CsosnDataset.Close;
  Origem_CsosnDataset.SetJsonData(Response.Result);
  Origem_CsosnDataset.Open;
  
  Origem_CsosnDataset.Edit;  
end;

procedure TFViewOrigem_CsosnEdit.XDataClientOrigem_CsosnDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewOrigem_CsosnEdit.XDataClientOrigem_CsosnDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewOrigem_CsosnEdit.Origem_CsosnDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewOrigem_CsosnEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewOrigem_CsosnEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.origem_csosn.form.message');
  lbMessage := TLabel.Create('view.origem_csosn.form.message.label');
  btCloseMessage := TButton.Create('view.origem_csosn.form.message.button');
  btCancel := TButton.Create('view.origem_csosn.form.btBack');
  btSave := TButton.Create('view.origem_csosn.form.btSave');
  btDelete := TButton.Create('view.origem_csosn.form.btDelete');
  lbnome := TLabel.Create('view.origem_csosn.form.lbnome');
  ednome := TDBEdit.Create('view.origem_csosn.form.ednome');
  lbcodigo := TLabel.Create('view.origem_csosn.form.lbcodigo');
  edcodigo := TDBEdit.Create('view.origem_csosn.form.edcodigo');
  lbexcluido := TLabel.Create('view.origem_csosn.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.origem_csosn.form.edexcluido');
  lbinclusao := TLabel.Create('view.origem_csosn.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.origem_csosn.form.edinclusao');
  lbalteracao := TLabel.Create('view.origem_csosn.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.origem_csosn.form.edalteracao');
  lbexclusao := TLabel.Create('view.origem_csosn.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.origem_csosn.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Origem_CsosnDataset := TXDataWebDataSet.Create(Self);
  Origem_CsosnDatasetnome := TStringField.Create(Self);
  Origem_CsosnDatasetcodigo := TIntegerField.Create(Self);
  Origem_CsosnDatasetexcluido := TBooleanField.Create(Self);
  Origem_CsosnDatasetinclusao := TDateTimeField.Create(Self);
  Origem_CsosnDatasetalteracao := TDateTimeField.Create(Self);
  Origem_CsosnDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientOrigem_CsosnGet := TXDataWebClient.Create(Self);
  XDataClientOrigem_CsosnDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbcodigo.BeforeLoadDFMValues;
  edcodigo.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Origem_CsosnDataset.BeforeLoadDFMValues;
  Origem_CsosnDatasetnome.BeforeLoadDFMValues;
  Origem_CsosnDatasetcodigo.BeforeLoadDFMValues;
  Origem_CsosnDatasetexcluido.BeforeLoadDFMValues;
  Origem_CsosnDatasetinclusao.BeforeLoadDFMValues;
  Origem_CsosnDatasetalteracao.BeforeLoadDFMValues;
  Origem_CsosnDatasetexclusao.BeforeLoadDFMValues;
  XDataClientOrigem_CsosnGet.BeforeLoadDFMValues;
  XDataClientOrigem_CsosnDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewOrigem_CsosnEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 427;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 367;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 367;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 367;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 192;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 189;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 6;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbcodigo.SetParentComponent(Self);
    lbcodigo.Name := 'lbcodigo';
    lbcodigo.Left := 24;
    lbcodigo.Top := 219;
    lbcodigo.Width := 14;
    lbcodigo.Height := 13;
    lbcodigo.Caption := 'codigo:';
    lbcodigo.Transparent := True;
    edcodigo.SetParentComponent(Self);
    edcodigo.Name := 'edcodigo';
    edcodigo.Left := 221;
    edcodigo.Top := 216;
    edcodigo.Width := 200;
    edcodigo.Height := 21;
    edcodigo.Enabled := True;
    edcodigo.TabOrder := 7;
    edcodigo.Text := 'edcodigo';
    edcodigo.DataField := 'codigo';
    edcodigo.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 246;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 243;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 8;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 273;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 270;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 9;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 300;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 297;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 10;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 327;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 324;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 11;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Origem_CsosnDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Origem_CsosnDataset.SetParentComponent(Self);
    Origem_CsosnDataset.Name := 'Origem_CsosnDataset';
    Origem_CsosnDataset.AfterApplyUpdates := Origem_CsosnDatasetAfterApplyUpdates;
    Origem_CsosnDataset.EntitySetName := 'Origem_Csosn';
    Origem_CsosnDataset.Connection := DMConnection.ApiConnection;
    Origem_CsosnDataset.Left := 176;
    Origem_CsosnDataset.Top := 8;
    Origem_CsosnDatasetnome.SetParentComponent(Origem_CsosnDataset);
    Origem_CsosnDatasetnome.Name := 'Origem_CsosnDatasetnome';
    Origem_CsosnDatasetnome.FieldName := 'nome';
    Origem_CsosnDatasetnome.Required := True;
    Origem_CsosnDatasetnome.Size := 255;
    Origem_CsosnDatasetcodigo.SetParentComponent(Origem_CsosnDataset);
    Origem_CsosnDatasetcodigo.Name := 'Origem_CsosnDatasetcodigo';
    Origem_CsosnDatasetcodigo.FieldName := 'codigo';
    Origem_CsosnDatasetcodigo.Required := True;
    Origem_CsosnDatasetexcluido.SetParentComponent(Origem_CsosnDataset);
    Origem_CsosnDatasetexcluido.Name := 'Origem_CsosnDatasetexcluido';
    Origem_CsosnDatasetexcluido.FieldName := 'excluido';
    Origem_CsosnDatasetexcluido.Required := False;
    Origem_CsosnDatasetinclusao.SetParentComponent(Origem_CsosnDataset);
    Origem_CsosnDatasetinclusao.Name := 'Origem_CsosnDatasetinclusao';
    Origem_CsosnDatasetinclusao.FieldName := 'inclusao';
    Origem_CsosnDatasetinclusao.Required := False;
    Origem_CsosnDatasetalteracao.SetParentComponent(Origem_CsosnDataset);
    Origem_CsosnDatasetalteracao.Name := 'Origem_CsosnDatasetalteracao';
    Origem_CsosnDatasetalteracao.FieldName := 'alteracao';
    Origem_CsosnDatasetalteracao.Required := False;
    Origem_CsosnDatasetexclusao.SetParentComponent(Origem_CsosnDataset);
    Origem_CsosnDatasetexclusao.Name := 'Origem_CsosnDatasetexclusao';
    Origem_CsosnDatasetexclusao.FieldName := 'exclusao';
    Origem_CsosnDatasetexclusao.Required := False;
    XDataClientOrigem_CsosnGet.SetParentComponent(Self);
    XDataClientOrigem_CsosnGet.Name := 'XDataClientOrigem_CsosnGet';
    XDataClientOrigem_CsosnGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientOrigem_CsosnGet, Self, 'OnLoad', 'XDataClientOrigem_CsosnGetLoad');
    XDataClientOrigem_CsosnGet.Left := 64;
    XDataClientOrigem_CsosnGet.Top := 8;
    XDataClientOrigem_CsosnDelete.SetParentComponent(Self);
    XDataClientOrigem_CsosnDelete.Name := 'XDataClientOrigem_CsosnDelete';
    XDataClientOrigem_CsosnDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientOrigem_CsosnDelete, Self, 'OnLoad', 'XDataClientOrigem_CsosnDeleteLoad');
    SetEvent(XDataClientOrigem_CsosnDelete, Self, 'OnError', 'XDataClientOrigem_CsosnDeleteError');
    XDataClientOrigem_CsosnDelete.Left := 64;
    XDataClientOrigem_CsosnDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbcodigo.AfterLoadDFMValues;
    edcodigo.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Origem_CsosnDataset.AfterLoadDFMValues;
    Origem_CsosnDatasetnome.AfterLoadDFMValues;
    Origem_CsosnDatasetcodigo.AfterLoadDFMValues;
    Origem_CsosnDatasetexcluido.AfterLoadDFMValues;
    Origem_CsosnDatasetinclusao.AfterLoadDFMValues;
    Origem_CsosnDatasetalteracao.AfterLoadDFMValues;
    Origem_CsosnDatasetexclusao.AfterLoadDFMValues;
    XDataClientOrigem_CsosnGet.AfterLoadDFMValues;
    XDataClientOrigem_CsosnDelete.AfterLoadDFMValues;
  end;
end;

end.
